import { useState, useEffect } from 'react'

import Api from 'services/api'

import { useSessionContext } from 'hooks/SessionContext'

export const defaultDealer = {
  address: '',
  city: '',
  state: '',
  zip: '',
  email: ''
}

const useDealerContactInfo = () => {
  const { session: { dealerId } } = useSessionContext()

  const [dealerContactInfo, setDealerContactInfo] = useState(defaultDealer)
  const [isDealerContactInfoLoaded, setIsDealerContactInfoLoaded] = useState(false)

  useEffect(() => {
    setDealerContactInfo(defaultDealer)

    if (!dealerId) return

    Api.Dealers.contactInfo(dealerId)
      .then((res) => {
        setDealerContactInfo(res)
        setIsDealerContactInfoLoaded(true)
      })
      .catch(() => {
        setDealerContactInfo(defaultDealer)
        setIsDealerContactInfoLoaded(true)
      })
  }, [dealerId])

  return { dealerContactInfo, isDealerContactInfoLoaded }
}

export default useDealerContactInfo
